import script from "./EventWaiverView.vue?vue&type=script&setup=true&lang=js"
export * from "./EventWaiverView.vue?vue&type=script&setup=true&lang=js"

import "./EventWaiverView.vue?vue&type=style&index=0&id=01633242&scoped=true&lang=scss"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01633242"]])

export default __exports__